import { TextInput } from '@molecules/index';
import { FormattedMessage } from 'react-intl';
import messages from '@pages/AdminPage/messages';
import { FlexContainer, Whitespace } from '@layout/index';
import { Button, FileUpload } from '@atoms/index';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styled from 'styled-components';

const CreateNewAudioMessageButton = styled(Button)`
  margin-left: 10px;
  width: 200px;
`;

export class IntroMessageCreateForm extends PureComponent {
  static propTypes = {
    createIntroMessage: PropTypes.func,
    setIntroMessageAudio: PropTypes.func,
    isFetching: PropTypes.bool,
    audioMessageFile: PropTypes.object,
  };

  createNewMessage = (e) => {
    e.preventDefault();
    const text = e.currentTarget.newIntroMessage.value.trim();
    if (!text) return;
    this.props.createIntroMessage({ text });
    e.target.reset();
  };

  createNewAudioMessage = () => {
    const { audioMessageFile } = this.props;
    if (audioMessageFile.name) {
      return this.props.createIntroMessage({ audioMessageFile });
    }
  };

  // Component FileUpload call method with the array of files, but we need only one file
  setCallAudioFile = ([file]) => this.props.setIntroMessageAudio(file);

  render() {
    const audioMessageFileName = _.get(
      this.props,
      'audioMessageFile.name',
      'Please select an audio file',
    );
    const { isFetching, audioMessageFile } = this.props;
    return (
      <FlexContainer gap="1rem">
        <FlexContainer vertical style={{ minWidth: '500px' }}>
          <form onSubmit={this.createNewMessage}>
            <TextInput
              underlined
              width="100%"
              name="newIntroMessage"
              id="new-intro-message"
              label={<FormattedMessage {...messages.createNewMessage} />}
            />
            <Whitespace size="1em" />
            <Button primary small>
              <FormattedMessage {...messages.create} />
            </Button>
          </form>
        </FlexContainer>
        <FlexContainer vertical>
          <TextInput
            disabled
            underlined
            width="100%"
            name="newIntroMessageFileName"
            id="new-intro-message-file-name"
            value={audioMessageFileName}
            label={<FormattedMessage {...messages.audioFileName} />}
          />
          <Whitespace size="1em" />
          <FlexContainer>
            <FileUpload
              id="audio-file-upload-input"
              audio
              small
              setFilesToUpload={this.setCallAudioFile}
              caption="Add audio file"
            />
            <Whitespace size="1em" />
            <CreateNewAudioMessageButton
              primary
              small
              disabled={!audioMessageFile.name || isFetching}
              loading={isFetching}
              onClick={this.createNewAudioMessage}
            >
              Create Audio Intro Message
            </CreateNewAudioMessageButton>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./components/pages/AdminPage/IntroMessageCreateForm.js